import React, { useState } from "react";
import ErrorMessage from "./errors/ErrorMessage";

export default function ImageUpload(props) {

  // Image Upload
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [imgUrl, setImgUrl] = useState([]);
  const [showModal, setShowModal] = React.useState(false);

  const readFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleUpload = async (e) => {
    setSuccess(false);
    if (e.target.files.length > 0) {
      setLoading(true);
      const file = await readFile(e.target.files[0]);

      try {
        const response = await fetch(
          "/.netlify/functions/uploadImage",
          {
            method: 'POST',
            body: file,
          }
        );

        if (response.status === 200) {
          const data = JSON.stringify(response);

          setSuccess(true);
          setImgUrl(data.url);
          props.changeVal("checkImage", data.url)
        } else {
          throw new Error(`Error: ${response.statusText}`);
        }
      }
      catch (error) {
        setSuccess(false);
        console.log(error);
      }
      setLoading(false);
    }
  }


  return (
    <div>
      <div className="flex flex-wrap -mx-3">
        <div className="w-full md:w-1/2 px-3 md:mb-0">
          <input id="upload" name={props.name} type="file" onChange={handleUpload} hidden />
          <label className="bg-gray-50 border border-gray-300 text-gray-500 sm:text-sm rounded-lg 
                focus:ring-primary-50 focus:border-primary-50 block w-full p-2.5 cursor-pointer" htmlFor="upload">{loading ? "Uploading..." : "Upload Void Check"}</label>
          {props.error ? (
            <div className="mt-2">
              <ErrorMessage message={props.message}></ErrorMessage>
            </div>
          ) : (
            ""
          )}
        </div>

        <div className="w-full md:w-1/2 px-3 md:mb-0">
          {success &&
            <>
              <span onClick={() => setShowModal(true)}>
                <div className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg ocus:ring-primary-50 focus:border-primary-50 block w-full p-2.5 cursor-pointer">
                  Show Uploaded Image
                </div>
              </span>
              {showModal ? (
                <div>
                  <div className="z-50 fixed top-0 left-0 flex items-center justify-center w-full h-full outline-none overflow-x-hidden overflow-y-auto"
                    id="exampleModalScrollable" tabIndex="-1" aria-labelledby="exampleModalScrollableLabel" aria-hidden="true">
                    <div className="max-w-lg my-6 mx-auto w-auto pointer-events-none">
                      <div className="max-h-full overflow-hidden border-none shadow-lg flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                        <img className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-50 focus:border-primary-50 block w-full p-2.5 cursor-pointer"
                          src={imgUrl} alt="Uploaded new" />
                        <div className="relative p-6 flex-auto">
                          {props.color ? (
                            <button
                              style = {{backgroundColor: props.color}}
                              className={`w-full text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center`}
                              type="button"
                              onClick={() => setShowModal(false)}
                            >
                              Close
                            </button>
                          ) : (
                            <button
                              className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                              type="button"
                              onClick={() => setShowModal(false)}
                            >
                              Close
                            </button>

                          )}


                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="opacity-60 fixed inset-0 z-99 bg-black flex-1"></div>
                </div>
              ) : null}
            </>
          }
        </div>

      </div>

    </div >

  )
}
